export default "__VITE_ASSET__79ca0da8__"